import OapSustainability from './code/Scripts/components/OapSustainability.vue';

export default {
  components: {
    OapSustainability,
  },
};
